export const TRANSFORM_TYPE_FIT = 'fit';
export const TRANSFORM_TYPE_FILL = 'fill';
